// extracted by mini-css-extract-plugin
export default {"page":"ChangelogPage_page__mH308","header":"ChangelogPage_header__iSDBa","title":"ChangelogPage_title__3xAGl","subtitle":"ChangelogPage_subtitle__9G+Fe"};